import { Components } from "@mui/material";

export const MuiCheckbox: Components["MuiCheckbox"] = {
  styleOverrides: {
    root: {
      color: "white",
    },
  },
};
